// This flag indicates that we have uploaded this geometry in the current frame
// and don't yet want to use the buffer for rendering, because that would cause
// a pipeline stall as the same buffer is being updated and used for rendering.
// Instead, we will use streaming draw in this frame, but then switch to using
// the buffer for rendering in the next frame.
export const STREAMING_DRAW_ONCE_DURING_UPLOAD = {};